import Vue from 'vue'
import myaxios from '@/myaxios.js'
import Router from 'vue-router'
import Login from '@/components/Login'
import SSOLogin from '@/components/SSOLogin'
import SSOLink from '@/components/SSOLink'
import Unauth from '@/components/Unauth'
import MobileLogin from '@/components/Mobile/Login.vue'
import MobileBaseInfo from '@/components/Mobile/BaseInfo.vue'
import MyInfo from '@/components/Mobile/MyInfo.vue'
import SurgeryDetail from '@/components/Mobile/SurgeryDetail.vue'
import TransferLogin from '@/components/Mobile/Transfer/Login.vue'
import TransferList from '@/components/Mobile/Transfer/TransferList.vue'
import TransferInfo from '@/components/Mobile/Transfer/TransferInfo.vue'
import ScoreInfo from '@/components/Mobile/Transfer/ScoreInfo.vue'
import ScoreDetail from '@/components/Mobile/Transfer/ScoreDetail.vue'
import CountingList from '@/components/Mobile/Transfer/CountingList.vue'
import IframeDoc from '@/components/Mobile/IframeDoc.vue'
import CountingSelect from '@/components/Mobile/Transfer/CountingSelect.vue'
import CountInstrument from '@/components/Mobile/Transfer/CountInstrument.vue'
import CountSupply from '@/components/Mobile/Transfer/CountSupply.vue'
import CountSupplyCreate from '@/components/Mobile/Transfer/CountSupplyCreate.vue'
import CountInstrumentCreate from '@/components/Mobile/Transfer/CountInstrumentCreate.vue'
import TransferLayout from '@/components/Mobile/Transfer/Layout.vue'
import DoucmentList from '@/components/Mobile/DoucmentList.vue'
import DoucmentInfo from '@/components/Mobile/DoucmentInfo.vue'

import S404 from '@/components/404'
import Icons from '@/components/Icons'
import Revive from '@/components/Anesthsia/Revive.vue'
import TakeHoliday from '@/components/Anesthsia/TakeHoliday.vue'
import ExchangeRoom from '@/components/Anesthsia/ExchangeRoom.vue'
import BloodGas from '@/components/Anesthsia/BloodGas.vue'
import SurgeryStop from '@/components/Anesthsia/SurgeryStop.vue'
import AnesTWBF from '@/components/Anesthsia/AnesTWBF.vue'
import TimeRulerSettings from '@/components/Anesthsia/TimeRulerSettings.vue'
import SurgeryReturn from '@/components/Anesthsia/SurgeryReturn.vue'
import CancelRecoveryApply from '@/components/Anesthsia/CancelRecoveryApply.vue'
import SurgeryCencelRescue from '@/components/Anesthsia/SurgeryCencelRescue.vue'
import MobileDeviceBind from '@/components/Anesthsia/MobileDeviceBind.vue'
import SurgeryRecovery from '@/components/Anesthsia/SurgeryRecovery.vue'
import KeyEventUpdateTime from '@/components/Anesthsia/KeyEventUpdateTime.vue'
import KeyEventEditDoc from '@/components/Anesthsia/KeyEventEditDoc.vue'
import SurgerySuspension from '@/components/Anesthsia/SurgerySuspension.vue'
import ParamSettings from '@/components/Anesthsia/ParamSettings.vue'
import VitalSign from '@/components/Anesthsia/VitalSign.vue'
import CreateVitalSign from '@/components/Anesthsia/CreateVitalSign.vue'
import HandoverAnes from '@/components/Anesthsia/Handover.vue'
import AnesLayout from '@/components/Anesthsia/Layout.vue'
import RecordTemplate from '@/components/Anesthsia/RecordTemplate.vue'
import DesktopRecordTemplateSaveAs from '@/components/Anesthsia/DesktopRecordTemplateSaveAs.vue'
import RecordOtherRemplatesSaveAs from '@/components/Anesthsia/RecordOtherRemplatesSaveAs.vue'
import RecordOtherTemplate from '@/components/Anesthsia/RecordOtherTemplate.vue'

import AnesNarcoticsBox from '@/components/Anesthsia/NarcoticsBox.vue'
import AdverseEventAnes from '@/components/Surgery/Adverse/Index.vue'
import DocumentAnes from '@/components/Surgery/Document/Index2.vue'
import Prescription from '@/components/Surgery/Prescription/Index.vue'
import ScoreAnes from '@/components/Surgery/Score/Index2.vue'
import AnesthesiaDesk from '@/components/Surgery/AnesthesiaDesk/Index.vue'
import WarnRecordList from '@/components/Anesthsia/WarnRecordList.vue'

import MedicalRecordAnes from '@/components/Surgery/MedicalRecord/Index.vue'
import BFJHZ from '@/components/Transfer/BFJHZ.vue'
import SaftyCheck from '@/components/Surgery/SaftyCheck/SaftyCheckNew.vue'
import ReviveExceptionalCase from '@/components/Anesthsia/ReviveExceptionalCase.vue'
import UsageDrugEvent from '@/components/Anesthsia/UsageDrugEvent.vue'
import Doc from '@/components/Anesthsia/Doc.vue'
import MessageSocketBox from '@/components/Anesthsia/MessageSocketBox.vue'
import MessageSend from '@/components/Message/MessageSend.vue'
import AnesthsiaMessageSend from '@/components/Message/AnesthsiaMessageSend.vue'
import AnesthsiaCheckPatient from '@/components/Anesthsia/AnesthsiaCheckPatient.vue'

import ChargeAnes from '@/components/Surgery/Charge/Index.vue'
import ReOperationsList from '@/components/Anesthsia/ReOperationsList.vue'
import Lis from '@/components/Surgery/Lis/Index.vue'
import Exam from '@/components/Surgery/Exam/Index.vue'
import MedicalHistory from '@/components/Surgery/MedicalHistory/Index.vue'
import AllOtherSystem from '@/components/Surgery/AllOtherSystem/Index.vue'
import ExtralPageNotFrame from '@/components/LayoutExtralPageNoFrame.vue'
import SignTest from '@/components/SignTest'
import ExtendMenu from '@/components/Surgery/Menu/ExtendMenu.vue'
import ChargeNew from '@/components/Surgery/Charge/ChargeNew.vue'
import BeforeSurgeryUseDrug from '@/components/Surgery/BeforeSurgeryUseDrug/Index.vue'
import OrderIndex from '@/components/Surgery/BeforeSurgeryUseDrug/OrderIndex.vue'
import UnloginBoardFamily from '@/components/Board/UnloginBoardFamily.vue'
import UnloginObstetricsBoardFamily from '@/components/Board/UnloginObstetricsBoardFamily.vue'
import RecoveryScreen from '@/components/Recovery/RecordScreen.vue'
import UnLoginBoardSchedule from '@/components/Board/UnLoginBoardSchedule.vue'
import UnloginDocument from '@/components/Surgery/Document/UnloginDocument.vue'
import UnloginDocIndex from '@/components/Surgery/Document/UnloginDocIndex.vue'
import UnLoginApplySurgery from '@/components/Scheduling/UnLoginApplySurgery.vue'
import FullcalendarScheduleSurgery from '@/components/Scheduling/FullcalendarScheduleSurgery.vue'
import UnLoginRightScheduleSurgery from '@/components/Scheduling/UnLoginRightScheduleSurgery.vue'
import Analgesic from '@/components/Surgery/Analgesic/Index.vue'
import DoctorScheduleSetup from '@/components/ScheduleShift/DoctorScheduleSetup.vue'
import UnLoginDoctorScheduleSetup from '@/components/ScheduleShift/UnLoginDoctorScheduleSetup.vue'
import UnLoginRecoverySchedule from '@/components/ScheduleShift/UnLoginRecoverySchedule.vue'
import compoundDrugBody from '@/components/Anesthsia/CompoundDrugBody.vue'
import humanBodyDiagram from '@/components/Anesthsia/HumanBodyDiagram.vue'
import humanBodyDiagramJKZT from '@/components/Anesthsia/humanBodyDiagramJKZT.vue'
import DentalAssessment from '@/components/Anesthsia/DentalAssessment.vue'
import _ from 'lodash'
import store from '../store/index.js'
// 导入Token过期检测工具
import { startTokenExpirationCheck, stopTokenExpirationCheck } from '@/utils/tokenExpiration'

Vue.use(Router)
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return routerPush.call(this, location, onResolve, onReject)
    return routerPush.call(this, location).catch(err => err)
}
const unAuth = [
    {
        path: `/404`,
        name: `S404`,
        meta: {
            requireAuth: false
        },
        component: S404
    },
    {
        path: `/m_login`,
        name: `MobileLogin`,
        meta: {
            requireAuth: false
        },
        component: MobileLogin
    },
    {
        path: `/m_baseInfo`,
        name: `MobileBaseInfo`,
        meta: {
            requireAuth: true
        },
        component: MobileBaseInfo
    },
    {
        path: `/m_detail`,
        name: `SurgeryDetail`,
        meta: {
            requireAuth: true
        },
        component: SurgeryDetail
    },
    {
        path: `/m_iframedoc`,
        name: `IframeDoc`,
        meta: {
            requireAuth: true
        },
        component: IframeDoc
    },
    {
        path: `/m_doucmentlist`,
        name: `DoucmentList`,
        meta: {
            requireAuth: true
        },
        component: DoucmentList
    },
    {
        path: `/m_doucmentinfo`,
        name: `DoucmentInfo`,
        meta: {
            requireAuth: true
        },
        component: DoucmentInfo
    },
    {
        path: `/myinfo`,
        name: `MyInfo`,
        meta: {
            requireAuth: true
        },
        component: MyInfo
    },
    {
        path: `/t_login`,
        name: `TransferLogin`,
        meta: {
            requireAuth: false
        },
        component: TransferLogin
    },
    {
        path: `/transfer_layout`,
        name: `TransferLayout`,
        meta: {
            requireAuth: false
        },
        children: [
            {
                path: `/t_transferList`,
                name: `TransferList`,
                meta: {
                    requireAuth: false
                },
                component: TransferList
            },
            {
                path: `/t_transferInfo`,
                name: `TransferInfo`,
                meta: {
                    requireAuth: true
                },
                component: TransferInfo
            }
        ],
        component: TransferLayout
    },
    {
        path: `/t_scoreInfo`,
        name: `ScoreInfo`,
        meta: {
            requireAuth: true
        },
        component: ScoreInfo
    },
    {
        path: `/t_scoreDetail`,
        name: `ScoreDetail`,
        meta: {
            requireAuth: true
        },
        component: ScoreDetail
    },
    {
        path: `/t_countinglist`,
        name: `CountingList`,
        meta: {
            requireAuth: true
        },
        component: CountingList
    },
    {
        path: `/t_countingselect`,
        name: `CountingSelect`,
        meta: {
            requireAuth: true
        },
        component: CountingSelect
    },
    {
        path: `/t_countinstrument`,
        name: `CountInstrument`,
        meta: {
            requireAuth: true
        },
        component: CountInstrument
    },
    {
        path: `/t_countsupply`,
        name: `CountSupply`,
        meta: {
            requireAuth: true
        },
        component: CountSupply
    },
    {
        path: `/t_countsupplycreate`,
        name: `CountSupplyCreate`,
        meta: {
            requireAuth: true
        },
        component: CountSupplyCreate
    },
    {
        path: `/t_countinstrumentcreate`,
        name: `CountInstrumentCreate`,
        meta: {
            requireAuth: true
        },
        component: CountInstrumentCreate
    },
    {
        path: `/unauth`,
        name: `Unauth`,
        meta: {
            requireAuth: false
        },
        component: Unauth
    },
    {
        path: `/login`,
        name: `Login`,
        meta: {
            requireAuth: false
        },
        component: Login
    },
    {
        path: `/ssologin`,
        name: `SSOLogin`,
        meta: {
            requireAuth: false
        },
        component: SSOLogin
    },
    {
        path: `/ssolink`,
        name: `SSOLink`,
        meta: {
            requireAuth: false
        },
        component: SSOLink
    },
    {
        path: `/signTest`,
        name: `SignTest`,
        meta: {
            requireAuth: false
        },
        component: SignTest
    },
    {
        path: `/icons`,
        name: `Icons`,
        meta: {
            requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
        },
        component: Icons
    },
    {
        path: `/bfjhz`,
        name: `BFJHZ`,
        meta: {
            requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
        },
        component: BFJHZ
    },
    {
        path: `/anes_desktop`,
        name: `AnesDesktop`,
        meta: {
            requireAuth: false
        },
        children: [
            {
                path: `/revive`,
                name: `Revive`,
                meta: {
                    requireAuth: false
                },
                component: Revive
            },
            {
                path: `/takeHoliday`,
                name: `TakeHoliday`,
                meta: {
                    requireAuth: false
                },
                component: TakeHoliday
            },
            {
                path: `/exchange_room`,
                name: `ExchangeRoom`,
                meta: {
                    requireAuth: false
                },
                component: ExchangeRoom
            },
            {
                path: `/blood_gas`,
                name: `BloodGas`,
                meta: {
                    requireAuth: false
                },
                component: BloodGas
            },
            {
                path: `/surgery_stop`,
                name: `SurgeryStop`,
                meta: {
                    requireAuth: false
                },
                component: SurgeryStop
            },
            {
                path: `/anes_twbf`,
                name: `AnesTWBF`,
                meta: {
                    requireAuth: false
                },
                component: AnesTWBF
            },
            {
                path: `/timeruler_settings`,
                name: `TimeRulerSettings`,
                meta: {
                    requireAuth: false
                },
                component: TimeRulerSettings
            },

            {
                path: `/surgery_return`,
                name: `SurgeryReturn`,
                meta: {
                    requireAuth: false
                },
                component: SurgeryReturn
            },
            {
                path: `/cancel_recovery_apply`,
                name: `CancelRecoveryApply`,
                meta: {
                    requireAuth: false
                },
                component: CancelRecoveryApply
            },
            {
                path: `/surgery_cencelrescue`,
                name: `SurgeryCencelRescue`,
                meta: {
                    requireAuth: false
                },
                component: SurgeryCencelRescue
            },
            {
                path: `/mobile_device_bind`,
                name: `MobileDeviceBind`,
                meta: {
                    requireAuth: false
                },
                component: MobileDeviceBind
            },
            {
                path: `/surgery_recovery`,
                name: `SurgeryRecovery`,
                meta: {
                    requireAuth: false
                },
                component: SurgeryRecovery
            },
            {
                path: `/keyevent_updatetime`,
                name: `KeyEventUpdateTime`,
                meta: {
                    requireAuth: false
                },
                component: KeyEventUpdateTime
            },
            {
                path: `/keyevent_editdoc`,
                name: `KeyEventEditDoc`,
                meta: {
                    requireAuth: false
                },
                component: KeyEventEditDoc
            },
            {
                path: `/surgery_suspension`,
                name: `SurgerySuspension`,
                meta: {
                    requireAuth: false
                },
                component: SurgerySuspension
            },
            {
                path: `/param_settings`,
                name: `ParamSettings`,
                meta: {
                    requireAuth: false
                },
                component: ParamSettings
            },
            {
                path: `/handover_anes`,
                name: `HandoverAnes`,
                meta: {
                    requireAuth: false
                },
                component: HandoverAnes
            },
            {
                path: `/vital_sign`,
                name: `VitalSign`,
                meta: {
                    requireAuth: false
                },
                component: VitalSign
            },
            {
                path: `/create_vital_sign`,
                name: `CreateVitalSign`,
                meta: {
                    requireAuth: false
                },
                component: CreateVitalSign
            },
            {
                path: `/record_templates`,
                name: `RecordTemplate`,
                meta: {
                    requireAuth: false
                },
                component: RecordTemplate
            },
            {
                path: `/record_templates_save_as`,
                name: `DesktopRecordTemplateSaveAs`,
                meta: {
                    requireAuth: false
                },
                component: DesktopRecordTemplateSaveAs
            },
            {
                path: `/record_other_templates_save_as`,
                name: `RecordOtherRemplatesSaveAs`,
                meta: {
                    requireAuth: false
                },
                component: RecordOtherRemplatesSaveAs
            },
            {
                path: `/record_other_template`,
                name: `RecordOtherTemplate`,
                meta: {
                    requireAuth: false
                },
                component: RecordOtherTemplate
            },

            {
                path: `/narcotics_box_usage`,
                name: `AnesNarcoticsBox`,
                meta: {
                    requireAuth: false
                },
                component: AnesNarcoticsBox
            },
            {
                path: `/warn_record_list`,
                name: `WarnRecordList`,
                meta: {
                    requireAuth: false
                },
                component: WarnRecordList
            },
            {
                path: `/adverse_event_anes`,
                name: `AdverseEventAnes`,
                meta: {
                    requireAuth: false
                },
                component: AdverseEventAnes
            },
            {
                path: `/score_anes`,
                name: `ScoreAnes`,
                meta: {
                    requireAuth: false
                },
                component: ScoreAnes
            },
            {
                path: `/anesthesia_desk`,
                name: `AnesthesiaDesk`,
                meta: {
                    requireAuth: false
                },
                component: AnesthesiaDesk
            },
            {
                path: `/document_anes`,
                name: `DocumentAnes`,
                meta: {
                    requireAuth: false
                },
                component: DocumentAnes
            },
            {
                path: `/prescription`,
                name: `Prescription`,
                meta: {
                    requireAuth: false
                },
                component: Prescription
            },
            {
                path: `/medical_record_anes`,
                name: `MedicalRecordAnes`,
                meta: {
                    requireAuth: false
                },
                component: MedicalRecordAnes
            },
            {
                path: `/safty_check`,
                name: `SaftyCheck`,
                meta: {
                    requireAuth: false
                },
                component: SaftyCheck
            },
            {
                path: `/revive_exceptional_case`,
                name: `ReviveExceptionalCase`,
                meta: {
                    requireAuth: false
                },

                component: ReviveExceptionalCase
            },
            {
                path: `/usage_drug_event`,
                name: `UsageDrugEvent`,
                meta: {
                    requireAuth: false
                },
                component: UsageDrugEvent
            },
            {
                path: `/human_BodyDiagram`,
                name: `HumanBodyDiagram`,
                meta: {
                    requireAuth: false
                },
                component: humanBodyDiagram
            },
            {
                path: `/human_BodyDiagram_jkzt`,
                name: `HumanBodyDiagramJKZT`,
                meta: {
                    requireAuth: false
                },
                component: humanBodyDiagramJKZT
            },
            {
                path: `/dental_assessment`,
                name: `DentalAssessment`,
                meta: {
                    requireAuth: false
                },
                component: DentalAssessment
            },
            {
                path: `/compound_drug_body`,
                name: `CompoundDrugBody`,
                meta: {
                    requireAuth: false
                },
                component: compoundDrugBody
            },

            {
                path: `/doc`,
                name: `Doc`,
                meta: {
                    requireAuth: false
                },
                component: Doc
            },
            {
                path: `/message_socket_box`,
                name: `MessageSocketBox`,
                meta: {
                    requireAuth: false
                },
                component: MessageSocketBox
            },
            {
                path: `/anesthsia_message_send`,
                name: `AnesthsiaMessageSend`,
                meta: {
                    requireAuth: false
                },
                component: AnesthsiaMessageSend
            },
            // 患者扫码
            {
                path: `/anesthsia_check_patient`,
                name: `AnesthsiaCheckPatient`,
                meta: {
                    requireAuth: false
                },
                component: AnesthsiaCheckPatient
            },
            {
                path: `/message_send`,
                name: `MessageSend`,
                meta: {
                    requireAuth: false
                },
                component: MessageSend
            },
            {
                path: `/anesthesia_charge_anes`,
                query: {
                    charge_type: 1
                },
                name: `ChargeAnes`,
                meta: {
                    requireAuth: false
                },

                component: ChargeAnes
            },
            {
                path: `/re_operations_list`,
                name: `ReOperationsList`,
                meta: {
                    requireAuth: false
                },
                component: ReOperationsList
            },
            {
                path: `/lis`,
                name: `lis`,
                meta: {
                    requireAuth: false
                },
                component: Lis
            },
            {
                path: `/exam`,
                name: `exam`,
                meta: {
                    requireAuth: false
                },
                component: Exam
            },
            {
                path: `/emr`,
                name: `emr`,
                meta: {
                    requireAuth: false
                },
                component: MedicalHistory
            },
            {
                path: `/extralpagenotframe`,
                name: `extralpagenotframe`,
                meta: {
                    requireAuth: false
                },
                component: ExtralPageNotFrame
            },
            {
                path: `/allsystems`,
                name: `allsystems`,
                meta: {
                    requireAuth: false
                },
                component: AllOtherSystem
            },

            {
                path: `/extendmenu`,
                name: `extendmenu`,
                meta: {
                    requireAuth: false
                },
                component: ExtendMenu
            },
            {
                path: `/chargenew`,
                name: `chargenew`,
                meta: {
                    requireAuth: false
                },
                component: ChargeNew
            },
            {
                path: `/before_surgery_use_drug`,
                name: `BeforeSurgeryUseDrug`,
                meta: {
                    requireAuth: false
                },
                component: BeforeSurgeryUseDrug
            },
            {
                path: `/order_index`,
                name: `OrderIndex`,
                meta: {
                    requireAuth: false
                },
                component: OrderIndex
            },
            {
                path: `/analgesic`,
                name: `analgesic`,
                meta: {
                    requireAuth: false
                },
                component: Analgesic
            }

        ],
        component: AnesLayout
    },
    { // 红房子产科家属屏免登录
        path: `/unlogin_obstetrics_board_family`,
        name: `UnloginObstetricsBoardFamily`,
        meta: {
            requireAuth: false
        },
        component: UnloginObstetricsBoardFamily
    },
    { // 家属屏/排程屏免登录
        path: `/unlogin_board_family`,
        name: `UnloginBoardFamily`,
        meta: {
            requireAuth: false
        },
        component: UnloginBoardFamily
    },
    { // 复苏屏免登录
        path: `/RecoveryScreen`,
        name: `RecoveryScreenQuery`,
        meta: {
            requireAuth: false
        },
        component: RecoveryScreen
    },
    {
        path: `/unlogin_board_schedule`,
        name: `UnLoginBoardSchedule`,
        meta: {
            requireAuth: false
        },
        component: UnLoginBoardSchedule
    },
    {
        path: `/unlogin_document`,
        name: `UnloginDocument`,
        meta: {
            requireAuth: false
        },
        component: UnloginDocument
    },
    {
        path: `/unlogin_doc`,
        name: `UnloginDocIndex`,
        meta: {
            requireAuth: false
        },
        component: UnloginDocIndex
    },
    { // 手术申请查询---免登录 http://localhost:8081/#/2/unlogin_surgery?user=surgeryview_123456
        path: `/unlogin_surgery`,
        name: `UnLoginApplySurgery`,
        meta: {
            requireAuth: false
        },
        component: UnLoginApplySurgery
    },
    { // 新排程
        path: `/fullcalendarScheduleSurgery`,
        name: `FullcalendarScheduleSurgery`,
        meta: {
            requireAuth: false
        },
        component: FullcalendarScheduleSurgery
    },
    { // 手术区排班
        path: `/doctor_schedule_setup`,
        name: `DoctorScheduleSetup`,
        meta: {
            requireAuth: false
        },
        component: DoctorScheduleSetup
    },
    { // 体征修改记录
        path: `/sign_modification`,
        name: `SignModification`,
        meta: {
            requireAuth: false
        },
        component: require(`@/components/SignModification`)
    },
    // 手术申请查询---免登录 http://localhost:8081/#/2/unlogin_calendarSurgery?user=admin_2
    {
        path: `/unlogin_calendarSurgery`,
        name: `UnLoginRightScheduleSurgery`,
        meta: {
            requireAuth: false
        },
        component: UnLoginRightScheduleSurgery
    },
    // 301麻醉排班大屏---免登录 http://localhost:8081/#/unlogin_doctor_schedule_setup?user=xiaorui|123456
    {
        path: `/unlogin_doctor_schedule_setup`,
        name: `UnLoginDoctorScheduleSetup`,
        meta: {
            requireAuth: false
        },
        component: UnLoginDoctorScheduleSetup
    },
    // 301复苏室排班大屏---免登录 http://localhost:8081/#/unlogin_recovery_schedule?user=xiaorui|123456
    {
        path: `/unlogin_recovery_schedule`,
        name: `UnLoginRecoverySchedule`,
        meta: {
            requireAuth: false
        },
        component: UnLoginRecoverySchedule
    }

]
const router = new Router({
    routes: unAuth
})
// 汇报登录状态的全局定时器
let loginStatetimer = null
// 多少S汇报一次登录状态
let loginStateHeartTime = 0
function uploadstate(clientPath) {
    console.log(loginStateHeartTime + `秒汇报一次登录状态`)
    console.log(`store.getters.currentUser`)
    console.log(store.getters.currentUser)
    if (store.getters.currentUser) {
        myaxios
            .getNoloading(`api/AcisSystem/Authorization/UploadLastLoginTime?clientPath=${clientPath}`)
            .then(data => {
                console.log(`登录状态汇报成功`)
            })
    }
}

function mobileRouterValid(menus, to, from, next) {
    let clientHeight = document.documentElement.clientHeight
    let clientWidth = document.documentElement.clientWidth
    store.commit(`setScreenHeight`, clientHeight)
    store.commit(`setScreenWidth`, clientWidth)
    let token = sessionStorage.getItem(`token`)
    if (to.path.indexOf(`m_`) > -1) {
        if (menus.findIndex(item => item.location === `m_login`) == -1) {
            alert(`没有移动护理权限，请检查license授权`)
            next({
                path: `/`
            })
        }
    } else if (to.path.indexOf(`t_`) > -1) {
        // App壳 设置的首页地址通过from 获取,from =患者转运App
        if (menus.findIndex(item => item.location === `t_login`) == -1) {
            alert(`没有患者转运抢单菜单，请检查license授权`)
            next({
                path: `/`
            })
        }
    }
    if (to.meta.requireAuth == undefined || to.meta.requireAuth) {
        if (token && token != `undefined`) {
            next()
        } else {
            if (from.path.indexOf(`m_`) > -1) {
                next({
                    path: `m_login`
                })
            } else if (from.path.indexOf(`t_`) > -1) {
                next({
                    path: `t_login`
                })
            }
        }
    } else {
        next()
    }
}

function pcRouterValid(to, from, next) {
    // 这里写个全局定时器汇报登录状态
    if (loginStateHeartTime == 0 && store.getters.currentUser) {
        store.dispatch(`ADD_SYS_CONFIG`).then(data => {
            console.log(data.LoginStateHeartTime)
            if (data.LoginStateHeartTime > 0) {
                loginStateHeartTime = data.LoginStateHeartTime
                if (loginStatetimer) {
                    clearInterval(loginStatetimer)
                }
                let clientPath = ``
                if (window.ClientPath) {
                    clientPath = window.ClientPath.clientPath
                }
                loginStatetimer = setInterval(function() {
                    uploadstate(clientPath)
                }, loginStateHeartTime * 1000)
            }
        })
    }
    // 从Desptop 路由的
    let fromDesptop = false
    if (typeof winformMsg != `undefined`) {
        fromDesptop = true
    }
    if (typeof winformMsg != `undefined` && to.query.token && to.query.token != `` && to.query.workbar) {
        sessionStorage.setItem(`token`, to.query.token)
    }
    // 这里处理，离开页面校验
    console.log(from)
    if (from && from.matched) {
        let from2 = _.clone(from)
        let checkBase = from2.matched.find(s => s.name.indexOf(`basic_info`) > -1 || s.name.indexOf(`local_anesthesia`) > -1)
        if (checkBase) {
            let leavingComponent = checkBase.instances.default
            if (leavingComponent && typeof leavingComponent.checkDataChangeAndPrompt === `function`) {
                let dataChanged = leavingComponent.checkDataChangeAndPrompt()
                if (dataChanged) {
                    const answer = window.confirm(`数据已变动，确定要离开吗？`)
                    if (!answer) {
                        // 用户选择不离开，则停止导航
                        throw new Error(`不跳转路由`)
                    } else { next() }
                }
            }
        }
    }

    let clientHeight = document.documentElement.clientHeight
    let clientWidth = document.documentElement.clientWidth
    if (to.query.token) {
        sessionStorage.setItem(`token`, to.query.token)
    }
    let token = sessionStorage.getItem(`token`)
    if (to.meta.requireAuth == undefined || to.meta.requireAuth) { // 判断该路由是否需要登录权限
        if (fromDesptop && (to.query.workerbar && to.query.workerbar == `false`)) {
            clientHeight = clientHeight + 120

            // 从Desptop 路由的 且 非登录 打开界面的 且 不需要 工作栏路由的
            if (to.query.token && to.query.token != ``) {
                sessionStorage.setItem(`token`, to.query.token)
                store.dispatch(`ADD_OtherSettingColumn`)
                store.dispatch(`ADD_ExtendColumnList`)
                if (store.getters.routers.length == 0) {
                    store.dispatch(`ADD_ROUNTER`).then((routers) => {
                        if (store.getters.routers.length == 0) {
                            console.log(`there is no routers`)
                            next({
                                path: `/unauth`
                            })
                        } else {
                            console.log(router)
                            router.addRoutes(store.getters.routers)
                            router.replace(to).catch(err => err)
                        }
                    }).catch((e) => {
                        console.log(`路由加载失败：`, e)
                    })
                } else if (to.matched.length == 0) {
                    if (store.getters.routers.length > 0 && to.path == `/`) {
                        let route = store.getters.routers[0]
                        next({
                            path: route.fullPath
                        })
                    } else {
                        console.log(`the rout path  is not access`)
                        next({
                            path: `/unauth`
                        })
                    }
                } else {
                    next()
                }
            } else {
                next({
                    path: `/login`,
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (token && token != `undefined`) {
                if (store.getters.routers.length == 0) {
                    store.dispatch(`ADD_WORKBAR`).then((routers) => {
                        if (store.getters.routers.length == 0) {
                            console.log(`there is no routers`)
                            next({
                                path: `/unauth`
                            })
                        } else {
                            router.addRoutes(store.getters.routers)
                            router.replace(to).catch(err => err)
                        }
                    }).catch((e) => {
                        console.log(`路由加载失败：`, e)
                    })
                } else if (to.matched.length == 0) {
                    if (store.getters.routers.length > 0 && to.path == `/`) {
                        let odWorkbar = _.orderBy(store.getters.workbar, `display_order`)
                        let route = odWorkbar[0].first_model
                        while (route.children.length > 0) {
                            route = route.children[0]
                        }
                        next({
                            path: route.fullPath
                        })
                    } else {
                        console.log(`the rout path  is not access`)
                        next({
                            path: `/unauth`
                        })
                    }
                } else {
                    next()
                }
            } else {
                next({
                    path: `/login`,
                    query: { redirect: to.fullPath }
                })
            }
        }
    } else {
        if (to.fullPath.indexOf(`/ssologin`) > -1) {
            store.dispatch(`Get_Menu`).then((menus) => {
                console.log(menus)
                if (menus.findIndex(item => item.location === `s_s_o_login`) != -1) {
                    next()
                } else {
                    alert(`没有单点登录权限，请检查license授权`)
                }
                console.log()
            }).catch((e) => {
                console.log(`路由加载失败：`, e)
            })
        } else {
            next()
        }
    }
    store.commit(`setScreenHeight`, clientHeight)
    store.commit(`setScreenWidth`, clientWidth)
}

// 验证token，存在才跳转
router.beforeEach((to, from, next) => {
    // 如果是去登录页，停止Token过期检测
    if (to.path === `/login` || to.path === `/m_login` || to.path === `/t_login`) {
        stopTokenExpirationCheck()
    }

    if (from != null && (from.fullPath.startsWith(`t_`) == true || from.fullPath.startsWith(`m_`) == true)) {
        store.dispatch(`Get_Menu`).then((menus) => {
            mobileRouterValid(menus, to, from, next)
        }).catch((e) => {
            console.log(`路由加载失败：`, e)
        })
    } else {
        pcRouterValid(to, from, next)
    }

    // 如果路由需要认证且有token，启动Token过期检测
    const token = sessionStorage.getItem(`token`)
    if ((to.meta.requireAuth === undefined || to.meta.requireAuth) && token && token !== `undefined`) {
        // 确保系统配置已加载到根实例
        if (store.state.currentUser) {
            // 从Vue根实例获取配置（通过store或直接访问）
            // 这里需要等待配置加载完成
            store.dispatch(`ADD_SYS_CONFIG`).then(config => {
                // 创建一个临时对象来模拟$root，包含配置
                const rootConfig = Object.assign({}, config)
                startTokenExpirationCheck(rootConfig)
            }).catch(e => {
                console.error(`获取系统配置失败:`, e)
            })
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js